var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 166,
    viewBox: "0 0 151 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9102 33.3203H124.91V151.56C124.91 153.735 124.046 155.821 122.508 157.359C120.971 158.896 118.885 159.76 116.71 159.76H34.1102C31.9354 159.76 29.8497 158.896 28.3119 157.359C26.7741 155.821 25.9102 153.735 25.9102 151.56V33.3203V33.3203Z",
    stroke: "#eb4a5a",
    strokeWidth: 10.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 33.3203H144.86",
    stroke: "#eb4a5a",
    strokeWidth: 10.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.499 33.32V14.2C103.499 12.0252 102.635 9.93953 101.098 8.40173C99.5599 6.86394 97.4742 6 95.2994 6H55.5594C53.3846 6 51.2989 6.86394 49.7611 8.40173C48.2233 9.93953 47.3594 12.0252 47.3594 14.2V33.32",
    stroke: "#eb4a5a",
    strokeWidth: 10.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3896 127.84V65.2402",
    stroke: "#eb4a5a",
    strokeWidth: 10.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4697 127.84V65.2402",
    stroke: "#eb4a5a",
    strokeWidth: 10.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/TrashIcon.de5061c8cb7c0bb937896a1151f80a00.svg";
export { ForwardRef as ReactComponent };